
import { mapState } from 'vuex'
import config from '@/modules/config/header'
import { isShowHeaderAndHideFooterFn } from '@/utils/utils'

export default {
  components: {},
  props: {
    propsData: {
      type: Object,
      default: () => {
        return {}
      },
    },
  },
  data() {
    return {
      // isLoaded: false,
      logoBlack: config[this.$route.params.site]?.logo[this.$route.params.lang],
      logoWhite:
        this.$route.params.site === 'cn'
          ? this.$route.params.lang === 'en'
            ? '~/assets/img/logo-cn-white.png'
            : '~/assets/img/white-logo-cn-express.png'
          : '~/assets/img/white-logo-en-express.png',
      moduleName: '',
      searchInput: '',
      announcementSidebar: {},
      isPopups: false,
      isScrolled: false,
    }
  },
  computed: {
    ...mapState({
      isHome: (state) => state.isHome,
      isHdFtMobile: (state) => state.isHdFtMobile,
      isPopup: (state) => state.isPopup,
      router: (state) => state.router,
      isAgree: (state) => state.cookie_agree.agree,
      site: (state) => state.site,
    }),

    isEu() {
      return this.site === 'eu'
    },
    // KR 产品详情页：与首页共用半透明渐变导航栏样式
    isKrProductDetail() {
      return (
        this.site === 'kr' &&
        (this.$route.path.includes('/productDetail') ||
          this.$route.path.includes('/koreasf')) &&
        !this.isHdFtMobile
      )
    },
    // 判断是否显示头部和隐藏底部
    isShowHeaderAndHideFooter() {
      return isShowHeaderAndHideFooterFn(this.$route, this.isHdFtMobile)
    },
    // 判断是否隐藏菜单按钮（只在移动端且路由为receiving_standard且channel=qrcode时隐藏）
    isHideMenuList() {
      // 只在移动端才考虑隐藏菜单
      if (!this.isHdFtMobile) {
        return false
      }

      const { path, query } = this.$route
      const isReceivingStandardPage = path.includes(
        '/support/querySupport/receiving_standard'
      )
      const isQrcodeChannel = query.channel === 'qrcode'
      return isReceivingStandardPage && isQrcodeChannel
    },
  },
  watch: {
    isPopup(val) {
      this.isPopups = val
      if (val) {
        // 禁止蒙层下面一起滚动
        document.body.style.overflow = 'hidden'
      } else {
        document.body.style.overflow = 'auto'
      }
    },
  },
  async mounted() {
    // eslint-disable-next-line nuxt/no-env-in-hooks
    if (process.client) {
      window.addEventListener('scroll', this.handleScroll, { passive: true })
      this.handleScroll()
    }
    try {
      // this.isLoaded = true
      // 获取重要公告
      const res = await this.$API.common.getAnnouncementSidebarApi()
      const pageInfo = res || {}
      this.announcementSidebar = pageInfo.announcementSidebar || {}
    } catch (e) {
      this.announcementSidebar = {}
    }
  },
  beforeDestroy() {
    // eslint-disable-next-line nuxt/no-env-in-hooks
    if (process.client) {
      window.removeEventListener('scroll', this.handleScroll)
    }
  },
  methods: {
    handleScroll() {
      if (process.client) {
        this.isScrolled = window.scrollY > 10
      }
    },
    setDefaultActive() {
      // 选中
      const fullPath = this.$route.fullPath
      const path = fullPath.split('?')[0]
      const moduleName = path.split('/')[3]
      this.moduleName = moduleName || 'home'
    },
    // 移动端点击菜单svg事件
    togglePopup() {
      this.isPopups = !this.isPopups
      this.$store.commit('saveIsPopup', this.isPopups)
    },
    // 移动端点击菜单外关闭左侧菜单
    closePopups() {
      this.$store.commit('saveIsPopup', false)
    },
    backToHomePage() {
      const curLang = this.$route.params.lang
      const curSite = this.$route.params.site
      const url = window.location.origin + '/' + curSite + '/' + curLang
      location.replace(url)
    },
  },
}
